import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Spinner from "../presentationals/Spinner";
import Error from "../Error";
import CustomPagination from "../pagination";

const CommonTable = forwardRef(
  ({ headers, keyArray, tableData, colSpanArray, timestamp }, ref) => {
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(20);
    const tableRef = useRef();

    useImperativeHandle(ref, () => ({
      initializePage: () => {
        console.log("here");
        setPage(0);
      },
    }));

    return (
      <div
        className="whitebox wow fadeInUp"
        data-wow-delay=".6s"
        data-wow-duration="0.7s"
      >
        <div ref={tableRef} className="tab-content">
          <div className="tab-pane fade in active">
            <div className="tabcontbox">
              {
                //if loading is true and teher is no error means waiting for data to come so show spinner
                tableData?.loading && !tableData?.error ? (
                  <Spinner />
                ) : //else if laoding is now false but an error is there then show error
                !tableData?.loading && tableData?.error ? (
                  <Error error={tableData?.error} />
                ) : (
                  //else if loading is not true and error also is not true, means there is response
                  <div
                    data-cy="earnings-table"
                    style={{ overflowX: "auto", whiteSpace: "nowrap" }}
                  >
                    <table className="table table-striped">
                      <thead>
                        <tr role="row">
                          {headers?.map((item, index) => (
                            <th
                              key={index}
                              colSpan={colSpanArray?.[index] ?? 1}
                              style={{
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                            >
                              {item}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {
                          //if data is present, show data
                          tableData?.data?.content?.length ? (
                            tableData.data.content
                              .slice(page * size, (page + 1) * size)
                              .map((obj, index) => {
                                return (
                                  <tr key={index}>
                                    {keyArray?.map((item, index) => (
                                      <td
                                        key={index}
                                        colSpan={colSpanArray?.[index] ?? 1}
                                        className="text-center"
                                      >
                                        {obj?.[item]}
                                      </td>
                                    ))}
                                  </tr>
                                );
                              })
                          ) : (
                            //if the response is empty, show no data available
                            <tr>
                              <td
                                className="text-center"
                                colSpan={
                                  colSpanArray
                                    ? colSpanArray.reduce(
                                        (acc, colSpan) => acc + colSpan,
                                        0
                                      )
                                    : headers?.length
                                }
                              >
                                No Data Available
                              </td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                    {tableData.data?.content?.length ? (
                      <div className="col-md-12 tableNew bottom-0 d-flex ">
                        <div className=" tableFooter flex-wrap p-2">
                          <CustomPagination
                            itemsPerPage={size}
                            setItemsPerPage={setSize}
                            pageNumber={page}
                            setPageNumber={setPage}
                            data={tableData.data}
                            pageSizeArray={[20, 30, 50]}
                            ref={tableRef}
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                )
              }
              {timestamp && (
                <div
                  className="card-timestamp border-top mt-2"
                  data-cy="card-timestamp"
                >
                  <i className="fa fa-history mr-2 mt-2 mb-0"></i>Updated on
                  {" " + timestamp}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default CommonTable;
